import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dateRangePicker: {
      border: "0 !important" as any,
      zIndex: 1000,
      marginBottom: 10,
      fontSize: "1rem",
      "&::before": {
        left: 0,
        right: 0,
        bottom: 0,
        content: '"\\00a0"',
        position: "absolute",
        transition:
          "border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        pointerEvents: "none"
      },
      "&::after": {
        left: 0,
        right: 0,
        bottom: 0,
        content: '""',
        position: "absolute",
        transform: "scaleX(0)",
        transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        borderBottom: "2px solid #3f51b5",
        pointerEvents: "none"
      }
    },
    calendar: {
      border: "0 !important" as any,
      boxShadow:
        "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
      borderRadius: 4
    }
  })
);

export const GlobalCss = withStyles(theme => ({
  "@global": {
    ".react-daterange-picker__wrapper": {
      border: "none"
    },
    ".react-daterange-picker__button": {
      color: "rgba(0, 0, 0, 0.54)",
      flex: "0 0 auto",
      padding: "6px 0px 6px 20px",
      overflow: "visible",
      "font-size": "1.5rem",
      "text-align": "center",
      transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "border-radius": "50%"
    },
    ".react-calendar__month-view__weekdays": {
      color: "rgba(0, 0, 0, 0.38)"
    },
    abbr: {
      "text-decoration": "none !important",
      "font-weight": "normal"
    },
    ".react-calendar__navigation__label__labelText--from": {
      "font-size": "1.2em !important"
    }
  }
}))(() => null);
